import { Card, CardBody, Col, Row } from "reactstrap";
import { TableContainer, ScreenOverlay, Spinner } from "../../../../components/Common/index";
import { useUserList } from "../../../../common/hooks/api/user";
import { toastError } from "../../../../helpers/toast-helper";
import usePagination from "../../../../common/hooks/pagination";
import { getResponseData } from "../../../../helpers/response-helper";
import { useNavigate } from "react-router-dom";

import { COLUMNS } from "../../config";

const UserList = () => {
    const {
        pagination,
        setPagination,

        sorting,
        setSorting,

        globalFilter,
        setGlobalFilter,

        params,

        getPageCount,
    } = usePagination();

    const navigate = useNavigate();

    const { data: userResponse, isLoading } = useUserList(params, {
        onError: () => {
            toastError("Cannot fetch users");
        }
    });
    const { data, meta } = getResponseData(userResponse);
    const pageCount = getPageCount(meta);

    return (
        <Row>
            <Col lg="12">
                <Card>
                    <CardBody>
                        <TableContainer
                            columns={COLUMNS}
                            data={data || []}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search..."
                            isCustomPageSize={true}
                            isAddButton={false}
                            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                            pagination="pagination"

                            manualPagination
                            paginationState={pagination}
                            onPaginationChange={setPagination}
                            pageCount={pageCount}

                            manualSorting
                            sortingState={sorting}
                            onSortingChange={setSorting}

                            manualGlobalFilter={true}
                            globalFilterState={globalFilter}
                            onGlobalFilterChange={setGlobalFilter}

                            onRowClick={(rowData) => {
                                navigate(`/users/${rowData.id}`);
                            }}
                        />
                    </CardBody>
                </Card>
            </Col>
            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </Row>
    );
};

export default UserList;
